import { useState } from "react";

const NAV_ITEMS = [
  { label: "本期观察", href: "#watch" },
  { label: "候选人榜单", href: "#rank" },
  { label: "提名盘点", href: "#nomi" },
  { label: "争夺动态", href: "#feed" },
  { label: "焦点图集", href: "#cover" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[#e4d9c6] bg-[#f6f0e6]/95 backdrop-blur-sm">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-baseline gap-2 whitespace-nowrap">
          <span className="font-display text-2xl font-black tracking-tight text-[#18130e]">
            黑料王
          </span>
          <span className="hidden text-[11px] uppercase tracking-[0.28em] text-[#b03a2e] sm:inline">
            Rumor Throne Weekly
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {NAV_ITEMS.map((it) => (
            <a
              key={it.href}
              href={it.href}
              className="whitespace-nowrap text-sm font-medium text-[#4a4036] transition-colors hover:text-[#b03a2e]"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#d9cbb2] text-[#4a4036] transition-colors hover:border-[#b03a2e] hover:text-[#b03a2e]"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <button
            type="button"
            aria-label="订阅本刊"
            className="hidden whitespace-nowrap rounded-full bg-[#b03a2e] px-5 py-2 text-sm font-semibold text-[#fbf7ef] transition-colors hover:bg-[#8f2a20] sm:block"
          >
            订阅周刊
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen(!open)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#d9cbb2] text-[#18130e] lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-[#e4d9c6] bg-[#f6f0e6] px-4 py-3 lg:hidden">
          <div className="mx-auto flex max-w-[1280px] flex-col gap-1">
            {NAV_ITEMS.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-medium text-[#18130e] hover:bg-[#ece2d0]"
              >
                {it.label}
              </a>
            ))}
            <button
              type="button"
              className="mt-2 whitespace-nowrap rounded-full bg-[#b03a2e] px-5 py-2.5 text-sm font-semibold text-[#fbf7ef]"
            >
              订阅周刊
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}